// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__GCJdR","HeaderMain":"Header_HeaderMain__oLoBB","SettingsLink":"Header_SettingsLink__9QdDu"};